import React from 'react';
import withStyles from 'components/common/wrappers/withStyles';

function Info({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <g
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        transform="translate(-476 -671) translate(438 281) translate(38 388) translate(0 2)"
      >
        <path d="M9.216 0A9.21 9.21 0 000 9.216a9.21 9.21 0 009.216 9.216 9.21 9.21 0 009.216-9.216A9.21 9.21 0 009.216 0zm0 16.992A7.772 7.772 0 011.44 9.216 7.772 7.772 0 019.216 1.44a7.772 7.772 0 017.776 7.776 7.772 7.772 0 01-7.776 7.776z" />
        <path d="M9.216 4.64a.72.72 0 00-.72.72v4.636a.72.72 0 101.44 0V5.36a.72.72 0 00-.72-.72z" />
        <circle cx="9.216" cy="12.57" r="1" />
      </g>
    </svg>
  );
}

Info.defaultProps = {
  color: '#e17b82',
};

export default withStyles(Info);
